import React, { useState } from 'react'
import Place from '../Definitions/Place';
import { Autocomplete, AutocompleteItem } from '@mantine/core';

/**
 * Creates an place selector
 * @param props 
 * @returns JSX.Element
 */
const SelectPlace = (props:
	{
		callback: (id: string, name: string) => void;
		placeholder: string;
		places: Place[];
		defaultValue: string;
		label: string;
	}): JSX.Element => {
	const { callback, label, defaultValue, placeholder, places } = props;
	const [value, setValueReal] = useState(defaultValue);
	const myPlace = {
		value: "here",
		name: "Min plats"
	};
	const defaultLocations = [myPlace].concat(places.map((item: Place) => {
		return {
			value: item.id,
			name: item.name
		}
	}));
	const [stopLocations, setstopLocations] = useState(defaultLocations);

	const search = (input: string) => {
		if (input !== undefined && input !== "") {
			const api_key = "0dfa9f28-d0a3-4e52-bce2-e12b093a3101";
			return fetch(
				"https://api.resrobot.se/v2.1/location.name?input=" + input +
				"&format=json&accessId=" + api_key)
				.then((response) => response.json())
				.then((data) => {
					let arr = data.stopLocationOrCoordLocation.map((item: any) => {
						return {
							value: item.StopLocation?.extId,
							name: item.StopLocation?.name
						}
					});
					arr = arr.filter((item: AutocompleteItem) => item.value !== undefined);
					//					arr.unshift(myPlace);
					setstopLocations(arr);
				})
		}
	};


	const setValue = (input: string) => {
		setValueReal(input);
		callback("", "");
		search(input);
	}

	const doCallback = (value: string, name: string) => {
		setValueReal(name);
		setstopLocations([]);
		callback(value, name);
	}

	return (
		<div style={{ width: "20em" }}>
			<Autocomplete
				value={value}
				label={label}
				defaultValue={defaultValue}
				onChange={setValue}
				filter={(value, item) => true}
				itemComponent={({ value, name }) =>
					<div
						onClick={() => doCallback(value, name)}>
						{name}
					</div>
				}

				data={value === "" ? defaultLocations : stopLocations}
				placeholder={placeholder}
			/>
		</div>
	)
}

export default SelectPlace